export default class Gymnasts {
    constructor() {
        this.section = document.querySelector('.gymnasts');
        this.gymnastCard = this.section.querySelectorAll('.gymnasts-card');
        this.btnCloseModal = this.section.querySelectorAll('.close-modal-gymnasts');

        this.ready();
    }

    ready() {
        this.gymnastCard.forEach((btn) => {
            btn.addEventListener('click', (event) => {
                const selectedId = event.target.getAttribute('data-id');
                const modalToOpen = document.querySelector(`#modal-${selectedId}`);

                if (modalToOpen) {
                    modalToOpen.classList.toggle('invisible', false);
                    modalToOpen.classList.toggle('visible', true);
                }

                this.closeModal(modalToOpen);
            });
        });
    }

    closeModal(modalToClose) {
        this.btnCloseModal.forEach((btn) => {
            btn.addEventListener('click', () => {
                modalToClose.classList.toggle('visible', false);
                modalToClose.classList.toggle('invisible', true);
            });
        });
    }
}

if (document.querySelector('.gymnasts')) {
    new Gymnasts();
}
